<template>
    <div class="modal-wrapper">
        <div class="modal-contaier">
            <component :is="component" :componentprops="componentprops" @disagree="disagree" @agree="agree" />
        </div>
    </div>
</template>

<script>

export default {
	name: "modal",
    props: ['component', 'componentprops'],
	data() {
		return {
            
		}
	},
	methods: {
        disagree() { this.$emit("disagree") },
        agree(value) { this.$emit("agree", value) }
	}
};
</script>
<style scoped>
    .modal-wrapper {
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0,0,0); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
        z-index: 99999;
    }
    .modal-contaier {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: calc(90% - 16px);
        max-width: 600px;
        background-color: white;
        padding: 16px;
        border-radius: 4px;
    }
</style>